import a from "./highrise1780.mjs";
function r(t) {
  return a(this, t).get(t);
}
export {
  r as default
};
